import OneProductPage from './OneProductPage';

export default OneProductPage;